module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/79cdb34da9e414fed91fcd376d98b259.gif";